export default {
      id: "visibility-show-usage",
      viewBox: "0 0 24 12",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#visibility-show",
      toString: function () {
        return this.url;
      }
    }